export const headers = [
    { field: "id", headerName: "ID", width: 70, hidden: true },
    { field: "codigo", headerName: "Codigo", width: 90 },
    { field: "descripcion", headerName: "Descripcion", width: 230 },
    { field: "ramo", headerName: "Ramo", width: 130 },
    { field: "web", headerName: "Web", width: 10 },
    { field: "app", headerName: "App", width: 10 },
  ];
  